import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { toast } from 'react-hot-toast';

export function useSettings(category: string) {
  const [settings, setSettings] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, [category]);

  const loadSettings = async () => {
    try {
      const { data, error } = await supabase
        .from('platform_settings')
        .select('*')
        .eq('category', category)
        .single();

      if (error) throw error;
      setSettings(data?.settings || {});
    } catch (error) {
      console.error(`Error loading ${category} settings:`, error);
      toast.error('Failed to load settings');
    } finally {
      setIsLoading(false);
    }
  };

  const updateSettings = async (updates: Record<string, any>) => {
    try {
      const newSettings = { ...settings, ...updates };
      
      const { error } = await supabase
        .from('platform_settings')
        .upsert({
          category,
          settings: newSettings,
          updated_at: new Date().toISOString()
        });

      if (error) throw error;
      
      setSettings(newSettings);
      toast.success('Settings updated successfully');
    } catch (error) {
      console.error(`Error updating ${category} settings:`, error);
      toast.error('Failed to update settings');
    }
  };

  return {
    settings,
    isLoading,
    updateSettings
  };
}